import { render } from "./Claim2_Main.vue?vue&type=template&id=85a3d4e2&scoped=true"
import script from "./Claim2_Main.vue?vue&type=script&lang=js"
export * from "./Claim2_Main.vue?vue&type=script&lang=js"

import "./Claim2_Main.vue?vue&type=style&index=0&id=85a3d4e2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-85a3d4e2"

export default script